import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-center px-4">
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-6">
          <i className="ri-error-warning-line text-primary-500 text-3xl"></i>
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-4">{t('notFound.title')}</h1>
        <p className="text-sm text-foreground-500 font-mono mb-2">{t('notFound.path')}: {location.pathname}</p>
        <p className="text-base text-foreground-600 mb-8 max-w-md mx-auto">{t('notFound.description')}</p>
        <a href="/" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap">
          <i className="ri-home-line"></i>
          {t('nav.home')}
        </a>
      </div>
    </div>
  );
}